import { format, parseISO, formatDistance } from 'date-fns';
import { HiCalendar as CalIcon } from "react-icons/hi";

export function EventDateTime({ dateTime, title }) {
  return (
    <div className="flex flex-col">
      <span className="block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase">
        <CalIcon className="inline-block" /> {title}
      </span>
      <time className="text-base text-gray-700" dateTime={dateTime}>
        {format(parseISO(dateTime), 'EEEE MMMM do, yyyy p')}
      </time>
      <span className="mt-1 text-sm text-gray-500">
        {formatDistance(parseISO(dateTime), new Date(), { addSuffix: true })}
      </span>
    </div>)
}
